var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedNodeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 0.5C1.05717 0.5 0.833313 0.723858 0.833313 1C0.833313 1.27614 1.05717 1.5 1.33331 1.5H10.6666C10.9428 1.5 11.1666 1.27614 11.1666 1C11.1666 0.723858 10.9428 0.5 10.6666 0.5H1.33331Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 3.16667C1.05717 3.16667 0.833313 3.39052 0.833313 3.66667C0.833313 3.94281 1.05717 4.16667 1.33331 4.16667H10.6666C10.9428 4.16667 11.1666 3.94281 11.1666 3.66667C11.1666 3.39052 10.9428 3.16667 10.6666 3.16667H1.33331Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 5.83333C1.05717 5.83333 0.833313 6.05719 0.833313 6.33333C0.833313 6.60948 1.05717 6.83333 1.33331 6.83333H10.6666C10.9428 6.83333 11.1666 6.60948 11.1666 6.33333C11.1666 6.05719 10.9428 5.83333 10.6666 5.83333H1.33331Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 8.5C1.05717 8.5 0.833313 8.72386 0.833313 9C0.833313 9.27614 1.05717 9.5 1.33331 9.5H10.6666C10.9428 9.5 11.1666 9.27614 11.1666 9C11.1666 8.72386 10.9428 8.5 10.6666 8.5H1.33331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedNodeLabel);
export default __webpack_public_path__ + "static/media/feed-node-label.ddf0b26e69f2416a4ddf48ae2e87fa21.svg";
export { ForwardRef as ReactComponent };